export const ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES = {
  ELEVATOR: 'elevator',
  GROUND: 'ground',
  ACCESSIBLE: 'accessible',
  SHOWER: 'shower',
  OTHER: 'other',
} as const

type AccommodationSpecialRequirementValue = typeof ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES[keyof typeof ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES]
type TranslatedAccommodationSpecialRequirementValue = Exclude<
  AccommodationSpecialRequirementValue,
  typeof ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES.OTHER
>

const ACCOMMODATION_SPECIAL_REQUIREMENT_TRANSLATION_KEYS: Record<TranslatedAccommodationSpecialRequirementValue, string> = {
  [ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES.ELEVATOR]:
    'booking_details_special_luggage_medical_equipment_acco_special_requirements_elevator_label',
  [ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES.GROUND]:
    'booking_details_special_luggage_medical_equipment_acco_special_requirements_ground_label',
  [ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES.ACCESSIBLE]:
    'booking_details_special_luggage_medical_equipment_acco_special_requirements_accessible_label',
  [ACCOMMODATION_SPECIAL_REQUIREMENT_VALUES.SHOWER]:
    'booking_details_special_luggage_medical_equipment_acco_special_requirements_shower_label',
}

interface MessageDescriptor {
  id: string
}

type FormatMessage = (descriptor: MessageDescriptor) => string

function isTranslatedRequirement(
  requirement: string,
): requirement is TranslatedAccommodationSpecialRequirementValue {
  return requirement in ACCOMMODATION_SPECIAL_REQUIREMENT_TRANSLATION_KEYS
}

export function translateAccommodationSpecialRequirements(
  requirements: string[] | undefined,
  formatMessage: FormatMessage,
): string[] {
  return (requirements ?? []).map((requirement) => {
    if (!isTranslatedRequirement(requirement))
      return requirement
    return formatMessage({ id: ACCOMMODATION_SPECIAL_REQUIREMENT_TRANSLATION_KEYS[requirement] })
  })
}
